import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/atoms';
import { NAV_PATHS } from '../../types/navigation';

/**
 * Shown while the dashboard playlist admin module is ahead of the current backend.
 * Playlists are user-owned in saung_backend (`/api/playlists`), not admin-managed.
 */
export const PlaylistsUnavailablePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="p-8 max-w-2xl">
      <h1 className="text-2xl font-bold text-gray-900">Playlists</h1>
      <p className="text-gray-600 mt-3 text-left">
        Admin playlist APIs are not available in the current Saung backend. Playlists are created
        and managed by end users through the mobile app, not through this admin dashboard.
      </p>
      <p className="text-gray-500 mt-2 text-sm text-left">
        Available backend routes are{' '}
        <code className="text-xs bg-gray-100 px-1 py-0.5 rounded">/api/playlists</code> and{' '}
        <code className="text-xs bg-gray-100 px-1 py-0.5 rounded">/api/public/playlists</code>,
        not <code className="text-xs bg-gray-100 px-1 py-0.5 rounded">/api/admin/playlists</code>.
      </p>
      <div className="mt-6 flex flex-wrap gap-3">
        <Button variant="primary" onClick={() => navigate(NAV_PATHS.SONGS)}>
          Go to Songs / Tracks
        </Button>
        <Button variant="outline" onClick={() => navigate(NAV_PATHS.ARTISTS)}>
          Go to Artists
        </Button>
      </div>
    </div>
  );
};

export default PlaylistsUnavailablePage;
